import Model from '@/shared/orm/Model'
import Role from './Role'
import i18n from '@/plugins/i18n'

export default class User extends Model {
    resourceName() {
        return 'users'
    }

    fields() {
        return ['id', 'name', 'email', 'password', 'password_confirmation']
    }

    get tableColumns() {
        return [
            { text: i18n.t('user.table-texts.name'), value: 'name' },
            { text: i18n.t('user.table-texts.email'), value: 'email' },
            {
                text: i18n.t('user.table-texts.actions'),
                value: 'action',
                sortable: false,
            },
        ]
    }

    get searchable() {
        return ['name']
    }

    relationships() {
        return {
            roles: new Role(),
        }
    }
}
